// extracted by mini-css-extract-plugin
export var chip = "_3g-0";
export var filterDropdown = "_3g-5";
export var filterItem = "_3g-6";
export var icon = "_3g-1";
export var removeButton = "_3g-3";
export var removeIcon = "_3g-4";
export var separator = "_3g-2";